import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ShieldIcon, MailIcon, LockIcon, ArrowLeftIcon } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { useAuth } from '../../lib/AuthContext';
import type { StaffRole } from '../../lib/types';
export function AdminLoginPage() {
  const navigate = useNavigate();
  const {
    adminLogin,
    isAdminLoggedIn
  } = useAuth();
  const [email, setEmail] = useState('long@myhoaphat.com');
  const [isLoading, setIsLoading] = useState(false);
  if (isAdminLoggedIn) {
    navigate('/admin/tong-quan', {
      replace: true
    });
    return null;
  }
  const handleLogin = () => {
    setIsLoading(true);
    setTimeout(() => {
      adminLogin(email, 'owner');
      setIsLoading(false);
      navigate('/admin/tong-quan');
    }, 600);
  };
  return <div className="min-h-screen flex items-center justify-center px-4" data-id="element-642">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="w-full max-w-sm" data-id="element-643">
        <div className="text-center mb-8" data-id="element-644">
          <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#C8A84E] to-[#B8963E] flex items-center justify-center mx-auto mb-4" data-id="element-645">
            <ShieldIcon className="w-8 h-8 text-[#0D0D0D]" data-id="element-646" />
          </div>
          <h1 className="text-2xl font-bold text-white" data-id="element-647">Admin Panel</h1>
          <p className="text-sm text-[#B0B0B0]" data-id="element-648">
            Mỹ Hòa Phát - Quản Lý Hệ Thống
          </p>
        </div>

        <div className="bg-[#1A1A1A] border border-[#2A2A2A] rounded-xl p-6 space-y-4" data-id="element-649">
          <Input label="Email" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="admin@myhoaphat.com" leftIcon={<MailIcon className="w-4 h-4" data-id="element-651" />} data-id="element-650" />
          <Input label="Mật khẩu" type="password" placeholder="••••••••" defaultValue="admin123" leftIcon={<LockIcon className="w-4 h-4" data-id="element-653" />} data-id="element-652" />
          <Button fullWidth onClick={handleLogin} isLoading={isLoading} data-id="element-654">
            Đăng Nhập
          </Button>
          <p className="text-xs text-[#666666] text-center" data-id="element-655">
            Demo: Nhấn đăng nhập với bất kỳ thông tin nào
          </p>
        </div>

        <Link to="/" className="flex items-center justify-center gap-2 mt-4 text-sm text-[#B0B0B0] hover:text-[#C8A84E] transition-colors" data-id="element-656">
          <ArrowLeftIcon className="w-4 h-4" data-id="element-657" />
          Về trang khách hàng
        </Link>
      </motion.div>
    </div>;
}